import { Injectable, inject, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AutomatedTransfersAlarmNotificationsParams } from '../../../../../../pages/transfers/automated-transfers/contract/automated-transfers-alarm-notifications-params.contract';
import { AutomatedTransfersNotificationsApiService } from '../../../../../../pages/transfers/automated-transfers/services/automated-transfers-notifications-api.service';
import { AcknowledgeAutomatedTransferNotificationCommand } from '../../../../../../pages/transfers/contract/acknowledge-automated-transfer-notificaton-command.contract';
import { AutomatedTransferNotification } from '../../../../../../pages/transfers/contract/automated-transfer-notification.contract';
import { AutomatedTransferNotificationsCount } from '../../../../../../pages/transfers/contract/automated-transfer-notifications-count.contract';
import { PagedResponse } from '../../../../../../shared/contract/paged-response.contract';

@Injectable({ providedIn: 'root' })
export class AutomatedTransfersNotificationsDatasourceService {
  private automatedTransfersNotificationsApiService = inject(AutomatedTransfersNotificationsApiService);

  private _currentActive$ = new BehaviorSubject<AutomatedTransferNotification[]>([]);
  private _currentActiveTotalCount$ = new BehaviorSubject<number>(0);

  public readonly currentActive$ = this._currentActive$.asObservable();
  public readonly currentActiveTotalCount$ = this._currentActiveTotalCount$.asObservable();

  private readonly CURRENT_ACTIVE_PAGE_SIZE = 5000; // proper pagination requires to rethink the UI's approach
  private readonly CURRENT_ACTIVE_PAGE = 0;
  private readonly CURRENT_ACTIVE_REQUEST_PARAMS: AutomatedTransfersAlarmNotificationsParams = {
    size: this.CURRENT_ACTIVE_PAGE_SIZE,
    page: this.CURRENT_ACTIVE_PAGE,
    sort: 'creationDate,desc',
  };

  $isNotificationsError = signal(false);

  public getCurrentActive(): Observable<AutomatedTransferNotification[]> {
    this.automatedTransfersNotificationsApiService.getCurrentActive(this.CURRENT_ACTIVE_REQUEST_PARAMS).subscribe({
      next: (res: PagedResponse<AutomatedTransferNotification>) => {
        this._currentActive$.next(res.content);
        this.$isNotificationsError.set(false);
      },
      error: () => {
        this.$isNotificationsError.set(true);
      },
    });
    return this._currentActive$;
  }

  public getCurrentActiveCount(): Observable<number> {
    this.automatedTransfersNotificationsApiService
      .getCurrentActiveCount()
      .subscribe((res: AutomatedTransferNotificationsCount) => {
        this._currentActiveTotalCount$.next(res.count);
      });
    return this._currentActiveTotalCount$;
  }

  public acknowledgeAutomatedTransferNotification(
    command: AcknowledgeAutomatedTransferNotificationCommand,
  ): Observable<string> {
    return this.automatedTransfersNotificationsApiService.acknowledgeAutomatedTransferNotification(command);
  }

  public acknowledgeAllAutomatedTransferNotifications(): Observable<void> {
    return this.automatedTransfersNotificationsApiService.acknowledgeAllAutomatedTransferNotifications();
  }
}
